import { ReactElement } from "react"
import styled from "@emotion/styled"
import { Grid } from "@mui/material"
import { BsDownload } from "react-icons/bs"

import { useTranslation } from "../TranslationProvider"

export default function DownloadSection(): ReactElement {
  const { t } = useTranslation()

  const handleDownload = (filename: string) => {
    const link = document.createElement("a")
    link.href = `/downloads/${filename}`
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <DownloadWrapper>
      <SectionTitle>{t("footer.downloads.title")}</SectionTitle>

      <SectionsContainer container>
        <Grid
          item
          xs={12}
          md={6}
          style={{ padding: 0, maxWidth: "fit-content" }}>
          <SectionWrapper>
            <SectionHeader>{t("footer.downloads.promotional")}</SectionHeader>

            <SectionDescription>
              {t("footer.downloads.promotionalDesc")}
            </SectionDescription>

            <DownloadButton
              onClick={() =>
                handleDownload("Step the Gap - Promotiepakket.zip")
              }>
              <BsDownload size={16} />
              {t("footer.downloads.download")}
            </DownloadButton>
          </SectionWrapper>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          style={{ padding: 0, maxWidth: "fit-content" }}>
          <SectionWrapper>
            <SectionHeader>{t("footer.downloads.riderTitle")}</SectionHeader>

            <SectionDescription>
              {t("footer.downloads.riderDesc")}
            </SectionDescription>

            <DownloadButton
              onClick={() =>
                handleDownload(
                  "Step the Gap - Rider - Stageplan - Input List.pdf"
                )
              }>
              <BsDownload size={16} />
              {t("footer.downloads.download")}
            </DownloadButton>
          </SectionWrapper>
        </Grid>

        {/* PRICING DOWNLOADS */}

        {/* <Grid
          item
          xs={12}
          md={6}
          style={{ padding: 0, maxWidth: "fit-content" }}>
          <SectionWrapper>
            <SectionHeader>{t("footer.downloads.pricingTitle")}</SectionHeader>

            <SectionDescription>
              {t("footer.downloads.pricingDesc")}
            </SectionDescription>

            <ButtonGroup>
              <DownloadButton
                onClick={() =>
                  handleDownload("Step the Gap - Prijslijst - Particulier.pdf")
                }>
                <BsDownload size={16} />
                {t("footer.downloads.individual")}
              </DownloadButton>

              <DownloadButton
                onClick={() =>
                  handleDownload("Step the Gap - Prijslijst - Zakelijk.pdf")
                }>
                <BsDownload size={16} />
                {t("footer.downloads.business")}
              </DownloadButton>
            </ButtonGroup>
          </SectionWrapper>
        </Grid> */}
      </SectionsContainer>
    </DownloadWrapper>
  )
}

const DownloadWrapper = styled.div`
  padding: 1rem;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`

const SectionTitle = styled.h2`
  margin: 0;

  color: var(--primary);
  font-weight: bold;
  text-align: center;

  user-select: none;
`

const SectionsContainer = styled(Grid)`
  width: 100%;

  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 1rem;
`

const SectionWrapper = styled.div`
  max-width: fit-content;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;

  text-align: center;
`

const SectionHeader = styled.h4`
  margin: 0;

  font-weight: 600;
  font-size: 1rem;

  user-select: none;
`

const SectionDescription = styled.p`
  margin: 0;

  font-size: 0.85rem;
  opacity: 0.8;
  line-height: 1.3;

  user-select: none;
`

// const ButtonGroup = styled.div`
//   display: flex;
//   gap: 0.75rem;
//   flex-wrap: wrap;
//   justify-content: center;
// `

const DownloadButton = styled.button`
  padding: 0.6rem 1.2rem;
  border: 2px solid var(--primary);
  border-radius: 0.4rem;
  background: transparent;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  color: var(--primary);
  font-family: "Filson Soft", Arial, sans-serif;
  font-size: 0.9rem;
  font-weight: 500;

  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background: var(--primary);
    color: var(--white);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media screen and (max-width: 600px) {
    font-size: 0.85rem;
    padding: 0.5rem 1rem;
  }
`
